<template>
    <nav class="navbar direction-ltr fixed-top header-responsive">
        <div class="container" v-if="baseInfo != null">
            <div class="navbar-translate">
                <router-link class="navbar-Category" to="/" :title="baseInfo.ShopName">
                    <img :src="baseInfo.LogoPicPath" height="24px" :title="baseInfo.ShopName" :alt="baseInfo.ShopName">
                </router-link>

                <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                        data-target="#navigation" aria-controls="navigation-index" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span class="navbar-toggler-bar bar1"></span>
                    <span class="navbar-toggler-bar bar2"></span>
                    <span class="navbar-toggler-bar bar3"></span>
                </button>
                <search-box></search-box>

            </div>

            <div class="collapse navbar-collapse justify-content-end" id="navigation">
                <div class="logo-nav-res default text-center">
                    <router-link to="/" :title="baseInfo.ShopName">
                        <img :src="baseInfo.LogoPicPath" height="36px" :title="baseInfo.ShopName" :alt="baseInfo.ShopName">
                    </router-link>
                </div>
                <div class="fix-tag">

                    <div @click="closeNav" class="inline-div"><router-link to="/" title="صفحه اصلی"><i class="now-ui-icons shopping_shop"></i></router-link></div>
                    <div @click="closeNav" class="inline-div">
                        <div class="router-a">
                            <router-link to="/cart" title="سبد خرید">
                                <i class="now-ui-icons shopping_cart-simple"></i>
                            </router-link>
                            <span v-if="cart != null" class="countItem">{{  cart.CartInfo.CartDetailsCount }} </span>
                        </div>
                    </div>
                    <div @click="closeNav" class="inline-div">
                        <router-link v-if="isUserLogined" to="/info" title="پروفایل کاربری"><i class="now-ui-icons users_single-02"></i></router-link>
                        <router-link v-if="!isUserLogined" to="/login" title="ورود"><i class="now-ui-icons users_single-02"></i></router-link>
                    </div>
                    <div class="di-bt-flex">
                        <span v-if="customerGroupId == 2" class="spn-panel">پنل همکاری</span>
                        <router-link class="btn btn-default btn-omdeh" to="/descriptionBulkPurchases" title="توضیحات خرید عمده">خرید عمده</router-link>

                    </div>
                </div>
                <hr class="hr-res" />
                <ul class="navbar-nav default">
                    <li v-for="group in groups" class="sub-menu">
                        <a class="f-a" :title="group.Title">{{group.Title}}</a>
                        <ul class="navbar-nav default">
                            <li v-for="subGruop in group.SubGroups" class="sub-menu">
                                <a :title="subGruop.Title">{{subGruop.Title}}</a>

                                <ul class="sub-menu sub-menu-bg">
                                    <li @click="closeNav">
                                        <router-link class="subgroub-li" :title="subGruop.Title" :to="{ name: 'filter' , query: { SubGroupId: subGruop.Id , SubGroupName: subGruop.Title.replace(/\s+/g, '-') }}">
                                            تمامی دسته ها <i class="fa fa-external-link" aria-hidden="true"></i>
                                        </router-link>
                                    </li>
                                    <li @click="closeNav" v-for="Category in subGruop.Categories">
                                        <router-link class="category-li" :title="Category.Title" :to="{name: 'filter' , query:{ CategoryId: Category.Id , CategoryName: Category.Title.replace(/\s+/g, '-') , SubGroupName: subGruop.Title.replace(/\s+/g, '-') , SubGroupId: subGruop.Id}}">{{ Category.Title }}</router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import searchBox from "./searchBox.vue"
    export default {
        data() {
            return {
                isUserLogined: false,
            }
        },
        components: {
            'search-box': searchBox
        },
        computed: {
            groups: function () {
                return this.$store.getters.readGroups;
            },
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
            customerGroupId: function () {
                return this.$store.getters.readCustomerGroupId;
            },
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        methods: {
            removeSearchValue() {
                this.searchValue = '';
            },
            closeNav() {
                $(function () {
                    $('#bodyClick').click();
                });
            }
        },
    }
</script>

<style scoped>
    .di-bt-flex {
        display:flex;
        justify-content:center;
        align-items:center;
    }
    .btn-omdeh {
        background-color: #dcbd91;
        padding: 4px 15px 6px 15px;
        margin-left: 10px;
        margin-right: 10px;
        color: #333 !important;
        padding: 1px 12px 5px 12px;
        border-radius: 7px;
        font-size: 14px;
        line-height: 1.9;
        
    }
    .spn-panel {
        background-color: #dcbd91;
        display: inline-block;
        margin-top: 0;
        color: #333;
        padding: 1px 12px 5px 12px;
        border-radius: 7px;
        font-size: 14px;
        line-height: 1.9;
    }
    .navbar-translate .navbar-Category {
        background-color: #fff;
    }

    ul.sub-menu-bg li a {
        background-color: #465157;
    }

    nav.header-responsive ul li ul li ul li .subgroub-li {
        padding-right: 50px;
    }

    .router-a {
        position: relative;
    }

        .router-a:hover .countItem {
            background-color: #5f7c12;
            color: #E5E5E5;
            transition: all .3s;
        }

    .countItem {
        position: absolute;
        right: 5px;
        top: 6px;
        background-color: #E5E5E5;
        padding: 5px;
        border-radius: 20px;
        width: 22px;
        height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #222;
    }

    .hr-res {
        border-top: 2px solid #555;
    }

    nav.header-responsive ul li ul li ul li .category-li {
        padding-right: 50px;
    }

    nav.header-responsive ul > li:hover a.f-a {
        background-color: #1d272a;
    }

    .fix-tag {
        text-align: center;
    }

        .fix-tag .inline-div {
            display: inline-block;
        }

        .fix-tag a:hover i {
            color: #5f7c12;
            transition: all .3s;
        }

        .fix-tag a i {
            font-size: 30px;
            color: #E5E5E5;
            margin: 15px;
            transition: all .3s;
        }

    @media only screen and (min-width:640px) and (max-width: 850px) {
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        nav.header-responsive form {
            position: relative;
            direction: rtl;
            float: right;
            height: 40px;
            width: 100%;
        }

        nav.header-responsive .search-nav ul.info-login {
            float: none;
            text-align: left;
        }

        nav.header-responsive .search-nav ul {
            width: 100%;
        }

            nav.header-responsive .search-nav ul.info-login {
                font-size: 10px !important;
                position: relative;
                top: -87px;
                left: -70px;
            }

            nav.header-responsive .search-nav ul i {
                font-size: 18px;
            }

        .js-search-keyword-link .c-search__result-item {
            font-size: 12px;
        }

        .c-search__results {
            left: 0px;
            max-height: 300px;
            overflow-y: scroll;
            padding: 0
        }

        nav.header-responsive .search-nav ul {
            overflow: auto;
        }

            nav.header-responsive .search-nav ul li {
                float: right;
            }

        nav.header-responsive .search-nav .cearchtags li a {
            display: inline;
        }

        nav.header-responsive .search-nav ul li a {
            font-size: 12px;
            color: #212121 !important;
            background: transparent;
            text-align: right;
            display: inline-block;
        }

        hr {
            display: inline-block;
            width: 100%;
        }

        .c-search__results ul li {
            line-height: 1.4;
        }

        .c-search ul li a {
            text-align: right;
        }
    }
</style>